import React, { useEffect, useRef, useState } from 'react';

// Trust-badge image for ZarinPal. The external CDN (cdn.zarinpal.com) can be
// blocked or unreachable in some networks, which previously logged a
// `Failed to load resource: net::ERR_TIMED_OUT` in the console for a plain
// <img>. This component instead loads the URL imperatively and, on failure,
// swaps to a clean inline fallback so the console stays quiet and the badge
// still renders.
const ZARINPAL_BADGE_URL = 'https://cdn.zarinpal.com/badges/trustLogo/1.svg';

const ZarinpalBadge = () => {
  const [failed, setFailed] = useState(false);
  const imgRef = useRef(null);

  useEffect(() => {
    // Preload; if it 404s/times out, fall back silently.
    const img = new window.Image();
    img.onload = () => setFailed(false);
    img.onerror = () => setFailed(true);
    img.src = ZARINPAL_BADGE_URL;
  }, []);

  if (failed) {
    return (
      <span
        className="inline-flex items-center justify-center w-full h-full"
        aria-label="ZarinPal"
      >
        <svg viewBox="0 0 120 80" className="w-full h-full">
          <text
            x="60"
            y="46"
            textAnchor="middle"
            style={{ font: 'bold 14px sans-serif', fill: '#1a1a1a' }}
          >
            ZarinPal
          </text>
        </svg>
      </span>
    );
  }

  return (
    <img
      ref={imgRef}
      src={ZARINPAL_BADGE_URL}
      alt="ZarinPal"
      className="w-full h-full object-contain mix-blend-multiply"
      onError={() => setFailed(true)}
    />
  );
};

export default ZarinpalBadge;
